module.exports = __webpack_public_path__ + "static/media/uj_szerzigeny2.ccdf2a8e.jpg";